import { render, staticRenderFns } from "./cp_c_inorg.vue?vue&type=template&id=10c6583e&"
import script from "./cp_c_inorg.vue?vue&type=script&lang=js&"
export * from "./cp_c_inorg.vue?vue&type=script&lang=js&"
import style0 from "./cp_c_inorg.vue?vue&type=style&index=0&id=10c6583e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports